import React, { Component, Fragment } from "react";

export default class SelectUnidade extends Component {

    constructor(props) {
        super(props);

        this.state = {
            unidades: [
                "5201183 Faculdade SENAI da Paraíba",
                "1117489 Centro de Formação Profissional Professor Stenio Lopes",
                "1117490 Centro de Inovação e Tecnologia Industrial - CITI",
                "1117488 Centro de Educação Profissional Odilon Ribeiro Coutinho",
                "1117487 Centro de Formação Prof. Eng. Jose William Lemos Leal",
                "1117491 Centro de Tecnologia do Couro e do Calçado Albano Franco",
                "5140965 Centro de Formação Profissional Miriam Benevides Gadelha",
                "1169095 Centro de Ações Móveis - CAM",
                "5297028 Centro de Formação Profissional Robson Braga de Andrade"
            ]
        }
    }

    render() {
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label>Unidade: </label>
                            <select name="select" onChange={this.props.selectUnidade} className="form-control" id={this.props.idComponente || "selectUnidade"}>
                                {this.state.unidades.map(unidade => {
                                    return(
                                        <option value={unidade}>{unidade}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}